var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9052 7.18295C6.82904 7.18295 7.57797 6.43403 7.57797 5.51018C7.57797 4.58633 6.82904 3.8374 5.9052 3.8374C4.98135 3.8374 4.23242 4.58633 4.23242 5.51018C4.23242 6.43403 4.98135 7.18295 5.9052 7.18295Z",
    fill: "#232428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1804 10.5594H8.62804C8.68081 10.5594 8.73141 10.5385 8.76872 10.5012C8.80603 10.4638 8.827 10.4132 8.827 10.3605V10.2401C8.8263 9.55293 8.55303 8.89414 8.06716 8.40827C7.58129 7.9224 6.9225 7.64913 6.23537 7.64844H5.57307C4.88594 7.64913 4.22715 7.9224 3.74128 8.40827C3.25541 8.89414 2.98214 9.55293 2.98145 10.2401V10.3605C2.98145 10.4132 3.00241 10.4638 3.03972 10.5012C3.07703 10.5385 3.12763 10.5594 3.1804 10.5594Z",
    fill: "#232428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.2929V1.56513C18 1.35684 17.9173 1.15709 17.77 1.00981C17.6227 0.862526 17.4229 0.779785 17.2147 0.779785H0.785341C0.577055 0.779785 0.377301 0.862526 0.230021 1.00981C0.0827411 1.15709 0 1.35684 0 1.56513V21.2929C0 21.5012 0.0827411 21.7009 0.230021 21.8482C0.377301 21.9955 0.577055 22.0782 0.785341 22.0782H17.2147C17.4229 22.0782 17.6227 21.9955 17.77 21.8482C17.9173 21.7009 18 21.5012 18 21.2929ZM16.4293 20.5075H1.57068V2.35047H16.4293V20.5075Z",
    fill: "#232428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7153 5.58838H9.62891V7.15906H15.7153V5.58838Z",
    fill: "#232428"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7153 8.73047H9.62891V10.3011H15.7153V8.73047Z",
    fill: "#232428"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.714 13.4429H2.55957V15.0136H15.714V13.4429Z",
    fill: "#232428"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.714 16.5835H2.55957V18.1542H15.714V16.5835Z",
    fill: "#232428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/CV.09b6ee8e147207ebed59b73d1669c3a0.svg";
export { ForwardRef as ReactComponent };